import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context){
	var base = '.b-policySlider';
	$(base, context).each(function(i, el){
		setTimeout(function() {
			new Swiper (el.querySelector('.b-policySlider-container'), {
				slidesPerView: 'auto',
				spaceBetween: 16,
				slideClass: 'b-policySlider-item',
				navigation : {
					nextEl : el.querySelector('.b-sliderArrows-btn_next'),
					prevEl : el.querySelector('.b-sliderArrows-btn_prev')
				},
				breakpoints: {
					1024: {
						spaceBetween: 24,
						slidesPerView: 3,
					},
					1380: {
						spaceBetween: 40,
						slidesPerView: 3,
					}
				},
			});
		});
	});
});
